import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import './LandingPageNew.css';

const PrivacyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="roofing-assist-landing-new" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar theme="light" />
      
      {/* Page Header */}
      <div style={{ textAlign: 'center', paddingTop: '80px', paddingBottom: '40px', paddingLeft: '20px', paddingRight: '20px' }}>
        <div style={{ color: '#d45c1a', fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '12px' }}>Legal Documents</div>
        <h1 style={{ fontFamily: "'Fraunces', 'Georgia', serif", fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', color: '#0c2036', fontWeight: 700, margin: 0, letterSpacing: '-0.02em' }}>Privacy Policy</h1>
        <div style={{ width: '40px', height: '3px', background: '#d45c1a', margin: '20px auto 0 auto', borderRadius: '2px' }}></div>
      </div>

      {/* Reader Card Container */}
      <div className="container" style={{ maxWidth: '880px', margin: '0 auto 80px auto', padding: '0 20px', flex: 1 }}>
        <div style={{
          background: '#ffffff',
          borderRadius: '8px',
          padding: 'clamp(30px, 6vw, 60px) clamp(20px, 5vw, 60px)',
          boxShadow: '0 12px 40px rgba(12, 32, 54, 0.04), 0 0 0 1px rgba(12, 32, 54, 0.03)',
          border: '1px solid rgba(12, 32, 54, 0.05)'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid rgba(12, 32, 54, 0.08)', paddingBottom: '20px', marginBottom: '40px' }}>
            <span style={{ fontSize: '11px', fontWeight: 700, color: '#d45c1a', letterSpacing: '0.05em' }}>DOCUMENT: PRIVACY POLICY</span>
            <span style={{ fontSize: '12px', color: '#405469', fontWeight: 500 }}>Last updated: April 2026</span>
          </div>

          <div style={{ fontFamily: "'Inter', sans-serif", color: '#405469', fontSize: '15px', lineHeight: '1.8' }}>
            <h2 style={{ fontFamily: "'Fraunces', 'Georgia', serif", color: '#0c2036', fontSize: '20px', fontWeight: 600, marginTop: '0', marginBottom: '16px' }}>1. Information We Collect</h2>
            <p style={{ marginBottom: '20px' }}>We collect information that you provide directly to us when you create an account, subscribe to our services, or contact customer support. This includes your name, email address, company details, and payment information.</p>
            <p style={{ marginBottom: '32px' }}>We also automatically collect certain information when you interact with RoofingAssist.AI, such as your IP address, browser type, operating system, and the dates and times of your visits.</p>

            <h2 style={{ fontFamily: "'Fraunces', 'Georgia', serif", color: '#0c2036', fontSize: '20px', fontWeight: 600, marginTop: '40px', marginBottom: '16px' }}>2. How We Use Your Information</h2>
            <p style={{ marginBottom: '32px' }}>We use the information we collect to operate, maintain, and improve our services. This includes processing transactions, providing customer support, analyzing usage patterns to enhance our offerings, and communicating with you about updates and administrative matters.</p>

            <h2 style={{ fontFamily: "'Fraunces', 'Georgia', serif", color: '#0c2036', fontSize: '20px', fontWeight: 600, marginTop: '40px', marginBottom: '16px' }}>3. Data Sharing and Disclosure</h2>
            <p style={{ marginBottom: '20px' }}>We do not sell your personal data. We may share your information with trusted third-party service providers who assist us in operating our platform, conducting business, or servicing you, so long as those parties agree to keep this information confidential.</p>
            <p style={{ marginBottom: '32px' }}>We may also release your information when we believe release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property, or safety.</p>

            <h2 style={{ fontFamily: "'Fraunces', 'Georgia', serif", color: '#0c2036', fontSize: '20px', fontWeight: 600, marginTop: '40px', marginBottom: '16px' }}>4. Data Security</h2>
            <p style={{ marginBottom: '32px' }}>We implement a variety of industry-standard security measures to maintain the safety of your personal information. However, no method of transmission over the Internet or method of electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
            
            <h2 style={{ fontFamily: "'Fraunces', 'Georgia', serif", color: '#0c2036', fontSize: '20px', fontWeight: 600, marginTop: '40px', marginBottom: '16px' }}>5. Your Privacy Rights</h2>
            <p style={{ marginBottom: '32px' }}>Depending on your location, you may have specific rights regarding your personal data, including the right to access, correct, or delete your information. To exercise these rights, please contact our support team.</p>

            <h2 style={{ fontFamily: "'Fraunces', 'Georgia', serif", color: '#0c2036', fontSize: '20px', fontWeight: 600, marginTop: '40px', marginBottom: '16px' }}>6. Contact Us</h2>
            <p style={{ marginBottom: '0' }}>If you have any questions regarding this Privacy Policy, please contact us at <a href="mailto:privacy@roofingassist.ai" style={{ color: '#d45c1a', textDecoration: 'none', fontWeight: 600 }}>privacy@roofingassist.ai</a>.</p>
          </div>
        </div>
      </div>

      {/* Credits */}
      <div className="bottom-credits">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} RoofingAssist.AI. All rights reserved.</p>
          <div style={{ marginTop: '10px' }}>
            <Link to="/">Home</Link>
            <Link to="/why-we-win">Why We Win</Link>
            <Link to="/privacy" className="active">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
